import axios from 'axios';
import useSWR from 'swr';

export const useZebelApiIntegration = (companyUid) => {
  const url = `/admin/zebel-api-integration/${companyUid}`;
  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};
